module.exports = __webpack_public_path__ + "media/app/assets/specializations/druid/guardian-6ea47e25776f7bcd751e1452a51578e3.png";